import { render, staticRenderFns } from "./addRoleModal.vue?vue&type=template&id=95ed29ce&scoped=true"
import script from "./addRoleModal.vue?vue&type=script&lang=js"
export * from "./addRoleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ed29ce",
  null
  
)

export default component.exports